import { render, staticRenderFns } from "./Dashboard_1.vue?vue&type=template&id=cece0b92&scoped=true&"
import script from "./Dashboard_1.vue?vue&type=script&lang=js&"
export * from "./Dashboard_1.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_1.vue?vue&type=style&index=0&id=cece0b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cece0b92",
  null
  
)

export default component.exports